import React from "react";
import { Link } from "react-router-dom";
import logo from "./../../../asset/img/Excite WLL.png";

const PRIMARY = "#a7cc48";
const DARK = "#2c2d3f";

export default function Header() {
  return (
    <nav style={s.nav}>
      <style>{`
        .reg-hdr-login:hover { background: rgba(167,204,72,0.2) !important; }
      `}</style>
      <div style={s.inner}>
        <Link to="/" style={{ lineHeight: 0 }}>
          <img src={logo} alt="Excite Enterprise" style={s.logo} />
        </Link>
        <div style={s.right}>
          <span style={s.hint}>Already have an account?</span>
          <Link to="/accounts?q=login" className="reg-hdr-login" style={s.loginBtn}>
            Log in
          </Link>
        </div>
      </div>
    </nav>
  );
}

const s = {
  nav: {
    background: DARK,
    borderBottom: `3px solid ${PRIMARY}`,
  },
  inner: {
    padding: "14px 6vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  logo: { height: 34 },
  right: { display: "flex", alignItems: "center", gap: 14 },
  hint: { fontSize: 13, color: "rgba(255,255,255,0.45)" },
  loginBtn: {
    background: "rgba(167,204,72,0.1)",
    border: "1.5px solid rgba(167,204,72,0.3)",
    color: PRIMARY,
    textDecoration: "none",
    padding: "7px 18px",
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    transition: "background 0.2s",
  },
};
